
import Icon from "@ant-design/icons";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const PlusSVG = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.625 10.625H13.375V2.375C13.375 1.61561 12.7594 1 12 1C11.2406 1 10.625 1.61561 10.625 2.375V10.625H2.375C1.61561 10.625 1 11.2406 1 12C1 12.7594 1.61561 13.375 2.375 13.375H10.625V21.625C10.625 22.3844 11.2406 23 12 23C12.7594 23 13.375 22.3844 13.375 21.625V13.375H21.625C22.3844 13.375 23 12.7594 23 12C23 11.2406 22.3844 10.625 21.625 10.625Z" fill="current" stroke="current"/>
</svg>);

export const PlusIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PlusSVG} {...props} />
);
